import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOilManageTankinList, getOilManageSupplierList, getOilManageOildepotList, getOilManageTankinSequenceList, postOilManageTankinUpdate, getOilManageTankinDetailList, getOilManageTransportList, postOilManageTankinDetailUpdate } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { postOilManageTankinCreate, getStationOilTankInfoList, postOilManageTankinOpenEnd } from '@/api/bairun/stationOilTankInfo'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';

var _this;

export default {
  name: 'OilUnloadingInfo',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatDate2: function formatDate2(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatDate3: function formatDate3(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'MM/dd hh:mm');
      } else {
        return '';
      }
    },
    formatAlarmStatusTag: function formatAlarmStatusTag(bool) {
      if (bool != null) {
        return bool === 1 ? 'primary' : 'danger';
      } else {
        return 'info';
      }
    },
    formatAlarmStatusName: function formatAlarmStatusName(row) {
      var alarmText = '';
      var alarmJson = '';

      if (row.alarmStatus == 1) {
        return '正常';
      }

      if (row.alarmStatusName && row.alarmStatusName != '') {
        try {
          alarmJson = JSON.parse(row.alarmStatusName);
        } catch (e) {
          return alarmJson;
        }

        for (var i in alarmJson) {
          if (alarmJson[i] != '') {
            alarmText += alarmJson[i] + '，';
          }
        }

        if (alarmText.length > 0) {
          return alarmText.substr(0, alarmText.length - 1);
        }
      }

      return alarmText;
    },
    formatOilTankStatusTag: function formatOilTankStatusTag(bool) {
      if (bool != null) {
        return bool === 1 ? 'success' : bool === 2 ? 'danger' : bool === 3 ? 'warning' : 'info';
      } else {
        return 'info';
      }
    },
    formatOilTankStatusText: function formatOilTankStatusText(bool) {
      if (bool != null) {
        return bool === 1 ? '使用中' : bool === 2 ? '已关停' : bool === 3 ? '维护中' : '未知';
      } else {
        return '';
      }
    }
  },
  data: function data() {
    return {
      colspanNum: 0,
      // 表格列数
      addDialogVisible: false,
      endDialogVisible: false,
      unloadOilDialogVisible: false,
      unloadOilDialogTitle: '',
      dialogVisible: false,
      // Dialog
      dialogFull: true,
      // Dialog全屏
      startDialogVisible: false,
      previewState: false,
      // 预览状态
      saveState: false,
      // 表单保存状态
      stationOptions: [],
      // 油站对象
      loading: true,
      // 加载动画
      searchInfo: {},
      // 搜索数据
      tableData: [],
      // 表格数据
      tableFootData: [],
      // 表格底部数据
      formData: {},
      // 表单列表数据
      createFormData: {
        stationId: '',
        tankInName: ''
      },
      yeweiyiTableData: [],
      formTable: [],
      // 表单获取数据
      formTemTable: [],
      // 表单临时数据
      transportList: [],
      // 运输单号列表
      supplierList: [],
      // 供应商列表
      oildepotList: [],
      // 油库列表
      tankinStartList: [],
      // 液位仪开始时间附近列表
      tankinEndList: [],
      // 液位仪结束时间附近列表
      // 计时器
      timer: null,
      timeDay: 0,
      timeHour: 0,
      timeMinute: 0,
      timeSecond: 0,
      // 分页
      page: 1,
      pageSize: 10,
      total: 0
    };
  },
  beforeDestroy: function beforeDestroy() {
    console.log('beforeDestroy');
    this.clearAllInterval();
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;
                _context3.next = 6;
                return _this3.getTableData();

              case 6:
                _context3.next = 8;
                return _this3.getOilManageSupplierLists();

              case 8:
                _context3.next = 10;
                return _this3.getOilManageOildepotLists();

              case 10:
                _context3.next = 12;
                return _this3.getOilManageTransportLists();

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 搜索
    onSubmit: function onSubmit() {
      this.getTableData();
    },
    // 百分比计算
    percentage: function percentage(oil, empty, water) {
      var total = oil + empty + water;
      var value = parseInt(oil / total * 100);
      return value + '%';
    },
    onInputDecimal: function onInputDecimal(e) {
      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
      this.$forceUpdate();
    },
    // 新建卸油单
    onCreate: function onCreate() {
      var date = new Date();
      var M = date.getMonth() + 1;
      var D = date.getDate();
      this.createFormData.tankInName = M + '月' + D + '日卸油';

      if (this.stationOptions.length == 1) {
        this.createFormData.stationId = this.stationOptions[0].ID;
      }

      this.addDialogVisible = true;
      this.$forceUpdate();
    },
    onCreateSave: function onCreateSave() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return postOilManageTankinCreate(_this4.createFormData);

              case 2:
                res = _context4.sent;

                if (res.code == 0) {
                  _this4.onSubmit();

                  _this4.dialogClose();
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 卸油
    onUnloadOil: function onUnloadOil(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.unloadOilDialogVisible = true;
                _this5.unloadOilDialogTitle = row.tankInName;

                _this5.refreshTankList(row.stationId, row.tankInNo);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    refreshTankList: function refreshTankList(stationId, tankInNo) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return getStationOilTankInfoList({
                  stationId: stationId,
                  page: 1,
                  pageSize: 9999
                });

              case 2:
                res = _context6.sent;
                res.data.list.forEach(function (item) {
                  item.tankInNo = tankInNo;
                  item.timeDay = 0;
                  item.timeHour = 0;
                  item.timeMinute = 0;
                  item.timeSecond = 0;
                });
                _this6.yeweiyiTableData = res.data.list;

                _this6.dateProceed(_this6.yeweiyiTableData);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 计时器
    dateProceed: function dateProceed(yeweiyiTableData) {
      var _this7 = this;

      this.clearAllInterval();
      var isUnloading = false;
      yeweiyiTableData.forEach(function (item) {
        if (item.tankInStatus == 1) {
          isUnloading = true;
        }
      });

      if (isUnloading) {
        setInterval(function () {
          var nowTime = Date.parse(new Date()) / 1000;
          yeweiyiTableData.forEach(function (tankItem) {
            if (tankItem.tankInStatus == 1) {
              var date = new Date(_this7.$options.filters.formatDate(tankItem.tankInOptStart));
              var time3 = Date.parse(date) / 1000;
              var time4 = nowTime - time3;
              var timeDay = Math.floor(time4 / 60 / 60 / 24);
              var timeHour = Math.floor(time4 / 60 / 60) - timeDay * 24;
              var timeMinute = Math.floor(time4 / 60) - timeDay * 24 * 60 - timeHour * 60;
              var timeSecond = Math.floor(time4) - timeDay * 24 * 60 * 60 - timeHour * 60 * 60 - timeMinute * 60;
              tankItem.timeDay = timeDay; // 天

              tankItem.timeHour = timeHour; // 小时

              tankItem.timeMinute = timeMinute; // 分钟

              tankItem.timeSecond = timeSecond; // 秒
            }
          });
          console.log('定时器');
        }, 1000);
      }
    },
    clearAllInterval: function clearAllInterval() {
      var num = setInterval(function () {}, 1000);

      for (var i = 0; i <= num; i++) {
        clearInterval(i);
      }
    },
    // 开始卸油表单填写
    startUnloadOil: function startUnloadOil(tankInfo) {
      this.formTable = [{
        'tankInNo': tankInfo.tankInNo,
        'stationId': tankInfo.stationId,
        'oilTankNo': tankInfo.oilTankNo,
        'tankNum': tankInfo.tankNum,
        'oilCode': tankInfo.oilCode,
        'oilSupplierNo': '',
        'depotNo': '',
        'tankNumTemp': '',
        'withdrawalTicketNo': '',
        'transportNo': '',
        'beforeTankTemperature': '',
        'beforeOilHeight': '',
        'beforeOilCapacity': ''
      }];
      this.startDialogVisible = true;
    },
    // 开始卸油
    doStartUnloadOil: function doStartUnloadOil(row) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res, param2, res2;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_this8.formTable[0].oilSupplierNo.trim() == '')) {
                  _context7.next = 3;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '供应商不能为空'
                });

                return _context7.abrupt("return");

              case 3:
                if (!(_this8.formTable[0].depotNo.trim() == '')) {
                  _context7.next = 6;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '发油单位不能为空'
                });

                return _context7.abrupt("return");

              case 6:
                if (!(_this8.formTable[0].tankNumTemp.trim() == '' || _this8.formTable[0].tankNumTemp <= 0)) {
                  _context7.next = 9;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '油罐编号不能为空'
                });

                return _context7.abrupt("return");

              case 9:
                if (!(_this8.formTable[0].tankNumTemp != _this8.formTable[0].tankNum)) {
                  _context7.next = 12;
                  break;
                }

                _this8.$confirm('油罐不匹配，您确定是【' + _this8.formTable[0].tankNumTemp + '号灌】正在卸【' + _this8.formTable[0].oilCode + '#】号油吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'error'
                });

                return _context7.abrupt("return");

              case 12:
                if (!(_this8.formTable[0].withdrawalTicketNo.trim() == '')) {
                  _context7.next = 15;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '提油单号不能为空'
                });

                return _context7.abrupt("return");

              case 15:
                if (!(_this8.formTable[0].transportNo.trim() == '')) {
                  _context7.next = 18;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '运输单号不能为空'
                });

                return _context7.abrupt("return");

              case 18:
                if (!(_this8.formTable[0].beforeTankTemperature.trim() == '')) {
                  _context7.next = 21;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '卸油前油罐温度不能为空'
                });

                return _context7.abrupt("return");

              case 21:
                if (!(_this8.formTable[0].beforeOilHeight.trim() == '')) {
                  _context7.next = 24;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '卸油前尺高度不能为空'
                });

                return _context7.abrupt("return");

              case 24:
                if (!(_this8.formTable[0].beforeOilCapacity.trim() == '')) {
                  _context7.next = 27;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '前尺升数不能为空'
                });

                return _context7.abrupt("return");

              case 27:
                _this8.formTable[0].tankInOptStart = _this8.$options.filters.formatDate(new Date());

                _this8.formatFormTable();

                _context7.next = 31;
                return _this8.updateUnloadOil(_this8.formTable[0], 1);

              case 31:
                res = _context7.sent;

                if (!(res.code == 0)) {
                  _context7.next = 38;
                  break;
                }

                param2 = {
                  'stationId': _this8.formTable[0].stationId,
                  'tankInNo': _this8.formTable[0].tankInNo,
                  'tankInStatus': 2,
                  // 2保存 3提交
                  'optType': 1,
                  // 1暂存 2保存
                  'list': [Object.assign(res.data, _this8.formTable[0])]
                };
                _context7.next = 36;
                return postOilManageTankinDetailUpdate(param2);

              case 36:
                res2 = _context7.sent;

                if (res2.code == 0) {
                  _this8.startDialogVisible = false;
                }

              case 38:
                _this8.$forceUpdate();

              case 39:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 结束卸油表单填写
    endUnloadOil: function endUnloadOil(tankInfo) {
      this.formTable = [{
        'tankInNo': tankInfo.tankInNo,
        'stationId': tankInfo.stationId,
        'oilTankNo': tankInfo.oilTankNo,
        'tankNum': tankInfo.tankNum,
        'oilCode': tankInfo.oilCode,
        'tankInOptStart': tankInfo.tankInOptStart,
        'oilInTon': '',
        'afterOilHeight': '',
        'afterOilCapacity': '',
        'afterTankTemperature': '',
        'oilTemperature': '',
        'oilDensity': ''
      }];
      this.endDialogVisible = true;
    },
    // 结束卸油
    doEndUnloadOil: function doEndUnloadOil() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res, param2, res2;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this9.formTable[0].afterOilHeight.trim() == '')) {
                  _context8.next = 3;
                  break;
                }

                _this9.$message({
                  type: 'warning',
                  message: '卸油后尺高度不能为空'
                });

                return _context8.abrupt("return");

              case 3:
                if (!(_this9.formTable[0].afterOilCapacity.trim() == '')) {
                  _context8.next = 6;
                  break;
                }

                _this9.$message({
                  type: 'warning',
                  message: '卸油后尺升数不能为空'
                });

                return _context8.abrupt("return");

              case 6:
                if (!(_this9.formTable[0].afterTankTemperature.trim() == '')) {
                  _context8.next = 9;
                  break;
                }

                _this9.$message({
                  type: 'warning',
                  message: '卸油后油罐温度不能为空'
                });

                return _context8.abrupt("return");

              case 9:
                if (!(_this9.formTable[0].oilTemperature.trim() == '')) {
                  _context8.next = 12;
                  break;
                }

                _this9.$message({
                  type: 'warning',
                  message: '视温不能为空'
                });

                return _context8.abrupt("return");

              case 12:
                if (!(_this9.formTable[0].oilDensity.trim() == '')) {
                  _context8.next = 15;
                  break;
                }

                _this9.$message({
                  type: 'warning',
                  message: '视密不能为空'
                });

                return _context8.abrupt("return");

              case 15:
                _this9.formatFormTable();

                _context8.next = 18;
                return _this9.updateUnloadOil(_this9.formTable[0], 2);

              case 18:
                res = _context8.sent;

                if (!(res.code == 0)) {
                  _context8.next = 25;
                  break;
                }

                param2 = {
                  'stationId': _this9.formTable[0].stationId,
                  'tankInNo': _this9.formTable[0].tankInNo,
                  'tankInStatus': 2,
                  // 2保存 3提交
                  'optType': 1,
                  // 1暂存 2保存
                  'list': [Object.assign(res.data, _this9.formTable[0])]
                };
                _context8.next = 23;
                return postOilManageTankinDetailUpdate(param2);

              case 23:
                res2 = _context8.sent;

                if (res2.code == 0) {
                  _this9.endDialogVisible = false;
                }

              case 25:
                _this9.$forceUpdate();

              case 26:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 更新卸油状态
    updateUnloadOil: function updateUnloadOil(tankInfo, state) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                param = {
                  oilTankNo: tankInfo.oilTankNo,
                  tankNum: tankInfo.tankNum,
                  optTime: _this10.$options.filters.formatDate(tankInfo.tankInOptStart),
                  optType: state,
                  stationId: tankInfo.stationId,
                  tankInNo: tankInfo.tankInNo
                };
                _context9.next = 3;
                return postOilManageTankinOpenEnd(param);

              case 3:
                res = _context9.sent;

                if (res.code == 0) {
                  _this10.refreshTankList(tankInfo.stationId, tankInfo.tankInNo);
                }

                return _context9.abrupt("return", res);

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    // 全部结束
    allFinished: function allFinished() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this11.$confirm('保存后不能再继续卸油，请完成所有卸油后再提交，确定吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'error'
                }).then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_) {
                    return regeneratorRuntime.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _this11.dialogConfirm(2);

                          case 1:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (_) {});

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    // 提交
    submit: function submit(row) {
      this.postOilManageTankinUpdates(row, 3, 3);
    },
    // 编辑
    edit: function edit(row) {
      this.colspanNum = 28;
      this.formData = row;
      this.getOilManageTankinDetailLists(row);
      this.dialogVisible = true;
      this.saveState = true; // 重置默认值

      this.tankinStartList = []; // 液位仪开始时间附近列表

      this.tankinEndList = []; // 液位仪结束时间附近列表
    },
    // 预览
    preview: function preview(row) {
      this.colspanNum = 26;
      this.getOilManageTankinDetailLists(row);
      this.saveState = false;
      this.previewState = true;
      this.formData = row;
      this.dialogVisible = true;
    },
    formatFormTable: function formatFormTable() {
      var _this12 = this;

      this.formTable.forEach(function (item) {
        if (item.tankNum !== undefined) {
          item.tankNum = Number(item.tankNum);
        }

        if (item.oilCode !== undefined) {
          item.oilCode = Number(item.oilCode);
        }

        if (item.beforeTankTemperature !== undefined) {
          item.beforeTankTemperature = Number(item.beforeTankTemperature);
        }

        if (item.beforeOilHeight !== undefined) {
          item.beforeOilHeight = Number(item.beforeOilHeight);
        }

        if (item.beforeOilCapacity !== undefined) {
          item.beforeOilCapacity = Number(item.beforeOilCapacity);
        }

        if (item.tankInOptStart !== undefined) {
          item.tankInOptStart = _this12.$options.filters.formatDate(item.tankInOptStart);
        }

        if (item.oilInTon !== undefined) {
          item.oilInTon = Number(item.oilInTon);
        }

        if (item.afterOilHeight !== undefined) {
          item.afterOilHeight = Number(item.afterOilHeight);
        }

        if (item.afterOilCapacity !== undefined) {
          item.afterOilCapacity = Number(item.afterOilCapacity);
        }

        if (item.afterTankTemperature !== undefined) {
          item.afterTankTemperature = Number(item.afterTankTemperature);
        }

        if (item.oilTemperature !== undefined) {
          item.oilTemperature = Number(item.oilTemperature);
        }

        if (item.oilDensity !== undefined) {
          item.oilDensity = Number(item.oilDensity);
        }

        if (item.transportOilTon !== undefined) {
          item.transportOilTon = Number(item.transportOilTon);
        }

        if (item.giveInTon !== undefined) {
          item.giveInTon = Number(item.giveInTon);
        }

        if (item.giveInCompareLiters !== undefined) {
          item.giveInCompareLiters = Number(item.giveInCompareLiters);
        }
      });
    },
    // 弹窗保存
    dialogConfirm: function dialogConfirm(optType) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var obj, res;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this13.formatFormTable();

                obj = {
                  'stationId': _this13.formData.stationId,
                  'tankInNo': _this13.formData.tankInNo,
                  'tankInStatus': 2,
                  // 2保存 3提交
                  'optType': optType,
                  // 1暂存 2保存
                  'list': _this13.formTable
                };
                _context12.next = 4;
                return postOilManageTankinDetailUpdate(obj);

              case 4:
                res = _context12.sent;

                if (res.code == 0) {
                  _this13.saveState = false;
                  _this13.dialogVisible = false;

                  _this13.getTableData();
                }

                return _context12.abrupt("return", res);

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    // 弹窗关闭前请求
    handleClose: function handleClose(done) {
      this.$confirm('您还没有保存，请问是否关闭？').then(function (_) {
        done();
      }).catch(function (_) {});
    },
    // 弹窗取消
    dialogCancel: function dialogCancel() {
      var _this14 = this;

      if (this.saveState) {
        this.$confirm('您还没有保存，请问是否关闭？').then(function (_) {
          _this14.saveState = false;
          _this14.dialogVisible = false;
        }).catch(function (_) {});
        return;
      }

      this.saveState = false;
      this.dialogVisible = false;
    },
    // 弹窗关闭
    dialogClose: function dialogClose() {
      this.dialogVisible = false;
      this.previewState = false; // 恢复默认值

      this.formTable = [];
      this.createFormData = {
        stationId: '',
        tankInName: ''
      };
      this.addDialogVisible = false;
      this.endDialogVisible = false;
    },
    // 点击液位仪开始时间附近列表
    tankinStartChange: function tankinStartChange(index, id, row) {
      var that = this;
      row.forEach(function (item) {
        if (id == item.ID) {
          console.log(item); // 液位仪更新时间

          that.formTable[index].oilStartAt = item.UpdatedAt; // 卸油开始液位仪油罐油位

          that.formTable[index].beforeOilHeight = item.oilHeight; // 卸油开始液位仪油罐油位

          that.formTable[index].beforeOilCapacity = item.oilCapacity;
        }
      });
    },
    // 清空液位仪开始时间附近列表
    tankinStartClear: function tankinStartClear(index, row) {
      // 液位仪更新时间
      this.formTable[index].oilStartAt = ''; // 卸油开始液位仪油罐油位

      this.formTable[index].beforeOilHeight = ''; // 卸油开始液位仪油罐油位

      this.formTable[index].beforeOilCapacity = '';
    },
    // 点击液位仪结束时间附近列表
    tankinEndChange: function tankinEndChange(index, id, row) {
      var that = this;
      row.forEach(function (item) {
        if (id == item.ID) {
          // 液位仪更新时间
          that.formTable[index].oilEndAt = item.UpdatedAt; // 卸油结束液位仪油罐油位

          that.formTable[index].afterOilHeight = item.oilHeight; // 卸油结束液位仪油罐油位

          that.formTable[index].afterOilCapacity = item.oilCapacity;
          console.log(item);
        }
      });
    },
    // 清空液位仪结束时间附近列表
    tankinEndClear: function tankinEndClear(index) {
      // 液位仪更新时间
      this.formTable[index].oilEndAt = ''; // 卸油结束液位仪油罐油位

      this.formTable[index].afterOilHeight = ''; // 卸油结束液位仪油罐油位

      this.formTable[index].afterOilCapacity = '';
    },
    // 获取液位仪开始时间附近列表
    tankinDateStartChange: function tankinDateStartChange(row, index) {
      var that = this;
      this.tankinStartList[index] = [];
      var obj = {
        'page': 1,
        'pageSize': 10,
        'optType': 1,
        'optTime': formatTimeToStr(row.optStartAt, 'yyyy-MM-dd hh:mm:ss'),
        'oilTankNo': row.oilTankNo,
        'stationId': row.stationId
      };
      getOilManageTankinSequenceList(obj).then(function (res) {
        if (res.code == 0 && res.data.list != null) {
          var arr = [];

          for (var i = 0; i < res.data.list.length; i++) {
            // 开始
            var obj2 = res.data.list[i];
            obj2['label'] = formatTimeToStr(res.data.list[i].UpdatedAt, 'MM-dd hh:mm:ss') + ' - ' + res.data.list[i].oilCapacity + '升';
            arr.push(obj2);
          }

          that.tankinStartList[index] = arr;
        }

        that.$forceUpdate();
      }, function (err) {});
    },
    // 合计
    count: function count(row, sort) {
      var numberSingle = 0;
      var numberDouble = 0;

      for (var i = 0; i < row.length; i++) {
        if (i % 2 == 0) {
          numberDouble += Number(row[i].value);
        } else {
          numberSingle += Number(row[i].value);
        }
      }

      if (sort == 0) {
        return numberDouble;
      }

      return numberSingle;
    },
    // 自定义获取基础资料
    getBasicData: function getBasicData(row, value, name, newName) {
      var str = '';
      console.log(row);
      row.forEach(function (item) {
        if (value == item[name]) {
          str = item[newName];
        }
      });
      return str;
    },
    // 获取液位仪结束时间附近列表
    tankinDateEndChange: function tankinDateEndChange(row, index) {
      var that = this;
      this.tankinEndList[index] = [];
      var obj = {
        'page': 1,
        'pageSize': 10,
        'optType': 2,
        'optTime': formatTimeToStr(row.optEndAt, 'yyyy-MM-dd hh:mm:ss'),
        'oilTankNo': row.oilTankNo,
        'stationId': row.stationId
      };
      getOilManageTankinSequenceList(obj).then(function (res) {
        if (res.code == 0 && res.data.list != null) {
          var arr = [];

          for (var i = 0; i < res.data.list.length; i++) {
            // 结束
            var obj2 = res.data.list[i];
            obj2['label'] = formatTimeToStr(res.data.list[i].UpdatedAt, 'MM-dd hh:mm:ss') + ' - ' + res.data.list[i].oilCapacity + '升';
            arr.push(obj2);
          }

          that.tankinEndList[index] = arr;
        }

        that.$forceUpdate();
      }, function (err) {});
    },
    // 获取列表
    getTableData: function getTableData() {
      var _this15 = this;

      var obj = {
        'page': this.page,
        'pageSize': this.pageSize,
        'stationId': this.searchInfo.stationId
      };
      getOilManageTankinList(obj).then(function (res) {
        if (res.code == 0) {
          _this15.tableData = res.data.list;
          _this15.total = res.data.total;
          _this15.loading = false;
        }
      }, function (err) {});
    },
    // 卸油信息状态更新
    postOilManageTankinUpdates: function postOilManageTankinUpdates(data, tankInStatus, optType) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var obj, res;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                obj = {
                  'stationId': data.stationId,
                  'tankInNo': data.tankInNo,
                  'tankInStatus': tankInStatus,
                  'optType': optType
                };
                _context13.next = 3;
                return postOilManageTankinUpdate(obj);

              case 3:
                res = _context13.sent;

                if (res.code == 0) {
                  _this16.getTableData();
                }

                return _context13.abrupt("return", res);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    // 卸油信息详情列表
    getOilManageTankinDetailLists: function getOilManageTankinDetailLists(data) {
      var _this17 = this;

      this.tableFootData = [];
      this.formTable = [];
      var obj = {
        'page': 1,
        'pageSize': 100,
        'stationId': data.stationId,
        'tankInNo': data.tankInNo
      };
      getOilManageTankinDetailList(obj).then(function (res) {
        if (res.code == 0 && res.data.list != null) {
          for (var i = 0; i < res.data.list.length; i++) {
            // this.tankinDateStartChange(res.data.list[i], i) //液位仪开始时间
            // this.tankinDateEndChange(res.data.list[i], i) //液位仪结束时间
            res.data.list[i].transportOilTon = res.data.list[i].transportOilTon == 0 ? '' : res.data.list[i].transportOilTon;
            res.data.list[i].transportOilLiters = res.data.list[i].transportOilLiters == 0 ? '-' : res.data.list[i].transportOilLiters;
            res.data.list[i].giveInTon = res.data.list[i].giveInTon == 0 ? '' : res.data.list[i].giveInTon;
            res.data.list[i].giveInLiters = res.data.list[i].giveInLiters == 0 ? '-' : res.data.list[i].giveInLiters;
            res.data.list[i].giveInCompareLiters = res.data.list[i].giveInCompareLiters == 0 ? '' : res.data.list[i].giveInCompareLiters;
            res.data.list[i].oilStandardDensity = res.data.list[i].oilStandardDensity == 0 ? '-' : res.data.list[i].oilStandardDensity;
            res.data.list[i].oilInTon = res.data.list[i].oilInTon == 0 ? '' : res.data.list[i].oilInTon;
            res.data.list[i].oilInLiters = res.data.list[i].oilInLiters == 0 ? '-' : res.data.list[i].oilInLiters;
            res.data.list[i].giveLossLiters = res.data.list[i].giveLossLiters == 0 ? '-' : res.data.list[i].giveLossLiters;
            res.data.list[i].oilSales = res.data.list[i].oilSales == 0 ? '-' : res.data.list[i].oilSales;
            res.data.list[i].sequenceInLiters = res.data.list[i].sequenceInLiters == 0 ? '-' : res.data.list[i].sequenceInLiters;
            res.data.list[i].oilLossLiters = res.data.list[i].oilLossLiters == 0 ? '-' : res.data.list[i].oilLossLiters;
            _this17.tableFootData[_this17.tableFootData.length] = {
              label: '吨数',
              value: res.data.list[i].oilInTon
            };
            _this17.tableFootData[_this17.tableFootData.length] = {
              label: '升数',
              value: res.data.list[i].oilInLiters
            };
          }

          _this17.formTable = res.data.list;
        } else {
          _this17.$message({
            message: '数据列表为空',
            type: 'error'
          });
        }
      }, function (err) {});
    },
    // 运输单号列表
    getOilManageTransportLists: function getOilManageTransportLists() {
      var _this18 = this;

      this.transportList = [];
      var obj = {
        'page': 1,
        'pageSize': 9999
      };
      getOilManageTransportList(obj).then(function (res) {
        if (res.code == 0) {
          _this18.transportList = res.data.list;
        }
      }, function (err) {});
    },
    // 供应商列表
    getOilManageSupplierLists: function getOilManageSupplierLists() {
      var _this19 = this;

      this.supplierList = [];
      var obj = {
        'page': 1,
        'pageSize': 9999
      };
      getOilManageSupplierList(obj).then(function (res) {
        if (res.code == 0) {
          _this19.supplierList = res.data.list;
          console.log(_this19.supplierList);
        }
      }, function (err) {});
    },
    // 油库列表
    getOilManageOildepotLists: function getOilManageOildepotLists() {
      var that = this;
      var obj = {
        'page': 1,
        'pageSize': 999
      };
      getOilManageOildepotList(obj).then(function (res) {
        if (res.code == 0 && res.data.list != null) {
          that.oildepotList = res.data.list;
        }

        that.$forceUpdate();
      }, function (err) {});
    },
    // 获取油站名称
    getStationName: function getStationName(id) {
      var _this = this;

      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    },
    // 分页处理
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    }
  }
};